<template>
  <ul class="nav nav-mobile-menu">
    <!-- <li>
      <md-field>
        <label>Search</label>
        <md-input v-model="search" type="text"></md-input>
      </md-field>
    </li> -->
    <li >
      <a v-if="host === 'open.kdzn.top'" href="http://docs.kdzn.top/" target="_blank" class="dropdown-toggle" data-toggle="dropdown" :style="{'color':'#3c4858 !important'}">
        <i :style="{'color':'#3c4858 !important'}" class="material-icons">description</i>
        <p>{{$I18n("document")}}</p>
      </a>
    </li>
    <li  v-if="host === 'open.kdzn.top'">
      <drop-down>
        <a slot="title" class="dropdown-toggle" data-toggle="dropdown" :style="{'color':'#3c4858 !important'}">
          <i class="material-icons" :style="{'color':'#3c4858 !important'}">language</i>
          <p>{{$I18n("language")}}</p>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <li><a :style="{'color':'#3c4858 !important'}" href="#" @click="changeLanguage('zh')">中文</a></li>
          <li><a :style="{'color':'#3c4858 !important'}" href="#" @click="changeLanguage('en')">English</a></li>
        </ul>
      </drop-down>
    </li>
    <li>
      <drop-down>
        <a slot="title" class="dropdown-toggle" data-toggle="dropdown" :style="{'color':'#3c4858 !important'}">
          <i class="material-icons" :style="{'color':'#3c4858 !important'}">person</i>
          <p>{{$I18n("personal_info")}}</p>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <li>
            <router-link :to="{path:'/user/info', query: {...$router.history.current.query}}">
              <p :style="{'color': 'rgb(60, 72, 88) !important'}" @click="changeMenuName($I18n('personal_info'))">
                {{$I18n("personal_info")}}
              </p>
            </router-link>
          </li>
          <li>
            <router-link :to="{path:'/user/bills', query: {...$router.history.current.query}}">
              <p :style="{'color': 'rgb(60, 72, 88) !important'}" @click="changeMenuName($I18n('bills'))">
                {{$I18n("bills")}}
              </p>
            </router-link>
          </li>
          <li><a :style="{'color':'#3c4858 !important'}" href="#" @click="checkExit">{{$I18n("logout")}}</a></li>
        </ul>
      </drop-down>
    </li>
    <modal 
      v-show="openModal" 
      @close="modal_classicModalHide" 
      class="lg-modal" 
    >
      <template slot="header">
        <h4 class="modal-title">{{$I18n("logout")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        {{$I18n("check_logout")}}
      </template>
      <template slot="footer">
        <md-button :style="{'margin-right':'16px'}" class="md-info" @click="modal_submit">{{$I18n("sure")}}</md-button>
        <md-button class="left-icon" @click="modal_classicModalHide">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </ul>
</template>
<script>

import { Modal } from '@/components';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      host: window.location.host,
      openModal: false,
      search: null,
      selectedEmployee: null,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
    };
  },
  methods:{
    modal_submit(){
      this.$api.logout({})
        .then(this.$Then(() => {
          localStorage.acc_token = ""; // 重置token状态
          this.$successMsg(this.$I18n('succ_num'))
          setTimeout(() => {
            this.$router.push({
              path: "/login",
              query: { ...this.$router.history.current.query },
            })
          }, 1000)
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    checkExit(){
      this.openModal = true;
    },
    modal_classicModalHide(){
      this.openModal = false;
    },
    changeLanguage(lang){
      if (lang === "zh"){
        this.$router.push({query: {}})
      } else {
        this.$router.push({query: { lang }})
      }
      this.$router.go(0)
    },
    changeMenuName(name){
      this.$emit('changeName', name)
    },

  },
};
</script>
